import { render, staticRenderFns } from "./top-sub-item.vue?vue&type=template&id=bf7bca86&"
import script from "./top-sub-item.vue?vue&type=script&lang=js&"
export * from "./top-sub-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports